<script setup lang="ts">
import type { RelationshipListing } from '../internal/types.ts'
import { Card, EmptyState } from '@taler/ui'
import { useI18n } from 'vue-i18n'
import LedgerAvatar from '@/features/relationships/components/LedgerAvatar.vue'
import RelationshipIcon from '@/features/relationships/components/RelationshipIcon.vue'

defineProps<{ connections: readonly RelationshipListing[] }>()

const { t } = useI18n()

function settlementLabel(settlement: RelationshipListing['settlement']): string {
  return settlement === 'CONTRIBUTION'
    ? t('relationships.settlementContribution')
    : t('relationships.settlementReimbursement')
}
</script>

<template>
  <section class="flex flex-col gap-[var(--space-block)]">
    <h2
      class="flex items-center gap-2 text-[length:var(--text-step-4)] font-semibold text-[color:var(--color-text)]"
    >
      <RelationshipIcon name="link" />
      {{ t('relationships.establishedTitle') }}
      <span v-if="connections.length > 0" class="text-[color:var(--color-text-muted)]"
        >({{ connections.length }})</span
      >
    </h2>

    <EmptyState v-if="connections.length === 0" :title="t('relationships.establishedEmpty')">
      <template #icon><RelationshipIcon name="link" /></template>
    </EmptyState>

    <ul v-else class="grid grid-cols-2 gap-3">
      <li v-for="connection in connections" :key="connection.otherLedgerId">
        <Card class="flex items-center gap-[var(--space-cell)]">
          <LedgerAvatar :id="connection.otherLedgerId" />
          <div class="flex min-w-0 flex-1 flex-col">
            <span
              class="truncate text-[length:var(--text-step-3)] font-medium text-[color:var(--color-text)]"
              >{{ connection.otherLedgerName }}</span
            >
            <span class="text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]">{{
              settlementLabel(connection.settlement)
            }}</span>
          </div>
        </Card>
      </li>
    </ul>
  </section>
</template>
